import React, { useState, useEffect } from "react";
import CustomTable from "../../../core/custom-table";
import ClaimsFilters from "./claims-filters";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import CreateClaims from "./create-clams";
import { Box, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteModal from "../../../components/delete-modal";
import AttachmentModal from "../../../components/attachment-modal";
import CustomButtonComponent from "../../../core/custom-button";
import { HeaderConfig } from "./config";
import SiFileUpload from "../../../core/file-uploader";
import { PAGE_LIMIT } from "../../../utils";

const Claims = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [editData, setEditData] = useState({});
  const [isDelete, setIsDelete] = useState({ isOpen: false, data: {} });

  const [filters, setFilters] = useState({
    page: 1,
    limit: PAGE_LIMIT,
    sortBy: "-createdAt",
  });
  const ClickHandler = (type, data) => {
    switch (type) {
      case "EDIT":
        setIsCreate(true);
        setEditData(data);
        break;
      case "DELETE":
        setIsDelete({ isOpen: true, data: data });
        break;
      default:
        break;
    }
  };
  const deleteHandler = () => {
    invokeApi(
      HTTP_METHODS.DELETE,
      `${HOSTNAME}${REST_URLS.CLAIMS}/${isDelete?.data?.id}`
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          toast.success("Deleted Successfully");
          setIsDelete({ isOpen: false, data: {} });
          loadData(filters);
        }
      })
      .catch((err) => console.error(err));
  };

  const downloadReports = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.CLAIMS}`,
      null,
      { download: "TRUE" },
      "blob"
    )
      .then((res) => {
        if (!res.message) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Claims.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((err) => console.error(err));
  };

  const loadData = (filters) => {
    const payload = { ...filters };
    setIsLoading(true);
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.CLAIMS}`, null, payload)
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          setData(res);
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    loadData(filters);
  }, []);
  return (
    <div className="page-body">
      <div className=" view-detailed-ticket">
        {isCreate && (
          <IconButton
            onClick={() => {
              setIsCreate(false);
              setEditData({});
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        <div>
          <p className="tab-name">Claims</p>
          <p className="section-name">Warranty Claims</p>
        </div>
      </div>
      {isCreate ? (
        <CreateClaims
          loadData={loadData}
          setIsCreate={setIsCreate}
          editData={editData}
          downloadReports={downloadReports}
        />
      ) : (
        <div>
          <div className="create-con">
            <p className="primary-text">Warranty Claim Form</p>
            <Box sx={{ display: "flex", gridGap: "20px" }}>
              <SiFileUpload
                fileTypes={[
                  ".csv",
                  ".xls",
                  ".xlsx",
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  "application/vnd.ms-excel",
                ]}
                title="Upload Bulk Claims"
                url={`${HOSTNAME}${REST_URLS.CLAIMS}/bulk-upload`}
                callBack={() => {
                  loadData({
                    page: 1,
                    sortBy: "-createdAt",
                    limit: PAGE_LIMIT,
                  });
                }}
              />
              <CustomButtonComponent
                variant="contained"
                color="success"
                onClick={downloadReports}
              >
                Download Claims
              </CustomButtonComponent>
              <CustomButtonComponent
                variant="contained"
                color="primary"
                onClick={() => setIsCreate(true)}
              >
                Create Warranty Claim
              </CustomButtonComponent>
            </Box>
          </div>
          <div className="si-hide-mobile">
            <CustomTable
              header={HeaderConfig}
              data={data.results || []}
              pageCount={data.totalPages}
              filters={filters}
              onClick={ClickHandler}
              onChange={(page) => {
                setFilters({
                  ...filters,
                  page,
                });
                loadData({
                  ...filters,
                  page,
                });
              }}
              filterCom={<ClaimsFilters loadData={loadData} />}
              isLoading={isLoading}
            />
          </div>
        </div>
      )}
      {isDelete?.isOpen && (
        <DeleteModal
          deleteHandler={deleteHandler}
          onClose={() => {
            setIsDelete({ isOpen: false, data: {} });
          }}
        />
      )}
    </div>
  );
};
export default Claims;
